import { render, staticRenderFns } from "./timeout.vue?vue&type=template&id=20140c88&scoped=true"
import script from "./timeout.vue?vue&type=script&lang=ts"
export * from "./timeout.vue?vue&type=script&lang=ts"
import style0 from "./timeout.vue?vue&type=style&index=0&id=20140c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20140c88",
  null
  
)

export default component.exports